module.exports = __webpack_public_path__ + "static/media/ic_categories_pet.d7ccb55d.svg";